import { FC, useContext } from "react";
import ProjectsContext from "../../contexts/data/ProjectsContext";
import { Box, Grid, GridProps, MenuItem, TextField, TextFieldProps } from "@mui/material";

interface IProjectMultiSelectProps extends Omit<TextFieldProps, 'variant' | 'onChange'>{
    GridProps?: GridProps,
    selectedProjectIds: number[],
    onChange: (projectIds: number[]) => any,
}

const ProjectMultiSelect: FC<IProjectMultiSelectProps> = ({
    GridProps,
    selectedProjectIds,
    onChange,
    slotProps,
    ...props
}) => {
    const {data: projects} = useContext(ProjectsContext);
    
    const handleProjectsChange = (event: any) => {
        onChange(event.target.value);
    }

    return (
        <Grid
            size={{
                xs: 12
            }}
            {...GridProps}
        >
            <TextField
                select
                fullWidth
                label="Projects"
                value={selectedProjectIds}
                slotProps={{
                    ...slotProps,
                    select: {
                        ...slotProps?.select,
                        multiple: true,
                        MenuProps: {
                            sx: {
                                maxHeight: 500
                            }
                        },
                        renderValue: (selected) => (
                            <Box sx={{ display: 'flex', flexDirection: "column", flexWrap: 'wrap', gap: 0.5 }}>
                                {
                                    (selected as number[]).map((value) => (
                                        <Box key={`project-filter-${value}`}>{projects?.find(x => x.id == value)?.name}</Box>
                                    ))
                                }
                            </Box>
                        )
                    }
                }}
                onChange={handleProjectsChange}
                {...props}
            >
                {
                    projects?.map(project => 
                        <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
                    )
                }
            </TextField>
        </Grid>
    );
}

export default ProjectMultiSelect;